import { connect } from 'react-redux';

import { TGSimplifiedBanner, ITGSimplifiedBannerOwnProps } from './TGSimplifiedBanner';
import { IWithTrackingProps } from '../../../../../hoc/withTracking';
import { prepareTrackingData } from '../../../../../../utils/prepareTrackingData';
import { IAppState } from '../../../../../../common/state';
import { shouldSendAdsEvent } from '../../../../../../utils/shouldSendAdsEvent';

export function mapStateToProps(state: IAppState): IWithTrackingProps {
  const { filters, results, userGADataLayerData, breadcrumbs, user } = state;

  return {
    tracking: prepareTrackingData(filters, results, breadcrumbs, userGADataLayerData),
    shouldSendAdsEvent: shouldSendAdsEvent(filters.jsonQuery),
    realtyUserId: user.isAuthenticated ? user.userId : undefined,
  };
}

export const TGSimplifiedBannerContainer = connect<IWithTrackingProps, {}, ITGSimplifiedBannerOwnProps>(
  mapStateToProps,
)(TGSimplifiedBanner);
